export default "__VITE_ASSET__BzLha15X__"